module.exports = __webpack_public_path__ + "img/google-play-badge.8710a625.png";